module.exports = __webpack_public_path__ + "static/Fabrik-Bold-6c27ab0d7b0a49c0912b46f14a7a51b3.eot";